module.exports = __webpack_public_path__ + "media/KikiE.1673d26c.mp3";